import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TEMPLATE_WHATSAPP_MEDIA} from "../../../../config";
import {environment} from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { WhatsappService } from '../../../whatsapp/whatsapp.service';

@Component({
  selector: 'app-content-preview',
  templateUrl: `./content-preview.component.html`,
  styles: []
})
export class ContentPreviewComponent implements OnInit {
  @Input() rowData: any;
  @Output() previewClick: EventEmitter<any> = new EventEmitter();
  data = '';

  constructor(
    private domSanitizer: DomSanitizer,
    private whatsappService: WhatsappService
  ) {

  }

  ngOnInit() {
    if (this.rowData.hasOwnProperty('template_content')) {
      this.rowData.template_content = this.getFormattedHTMLOfWhatsAppText(this.rowData.template_content);
    }
  }

  onPreviewClick() {
    this.previewClick.emit(this.rowData);
    this.data = this.rowData['content'];
  }

  downloadMedia(attachmentId, ctype, name) {
    let targetUrl = `${environment.whatspp_api_url}${TEMPLATE_WHATSAPP_MEDIA}`;
    window.open(targetUrl + attachmentId + '?ctype=' + ctype + '&name=' + name);
    return false;
  }

  locateOnMap(lat, lng) {
    window.open('https://maps.google.com/maps?q='+lng+','+lat+'&hl=es;z=14&amp;output=embed');
    return false;
  }

  getFormattedResponse(str) {
    if (str) {
      // spaces will be properly handled by CSS white-space property
      str = str.replace(/\\n|\n/g, "<br>");
      str = this.domSanitizer.bypassSecurityTrustHtml(str)
      return str;
    }
    else return '';
  }

  getFormattedHTMLOfWhatsAppText(htmlText) {
    return this.whatsappService.getFormattedHTMLOfWhatsAppText(htmlText);
  }
}
